import gql from 'graphql-tag';

import dokkioUserDashboardFragment from '../fragments/dokkioUserDashboardFragment';

export const mutationUpdateDokkioUserDashboard = gql`
  mutation updateDokkioUserDashboard(
    $status: DokkioUserDashboardStatus
    $userInstructions: String
  ) {
    updateDokkioUserDashboard(
      status: $status
      userInstructions: $userInstructions
    ) {
      ...dokkioUserDashboardFragment
    }
  }
  ${dokkioUserDashboardFragment}
`;
export default mutationUpdateDokkioUserDashboard;
